/**
 * PartnersStrip — Auto-scrolling client name marks.
 */
const PARTNERS = [
  "Amazon",
  "Powerling",
  "Honda",
  "LanguageLine Solutions",
  "JPMorgan Chase",
  "Trusted Translations",
  "TransPerfect",
  "Daviess Community Hospital",
  "Proprio",
  "Bob Evans Farms",
  "PoliLingua",
  "Bayantech",
  "Pfizer",
  "Transfective",
  "Hybrid Lynx",
  "The Loc Masters",
];

function Mark({ name }) {
  return (
    <div className="flex items-center px-9 select-none whitespace-nowrap">
      <span className="text-[15px] lg:text-[18px] font-semibold tracking-[0.14em] text-[#071D49]/65 group-hover:text-[#071D49] transition-colors">
        {name}
      </span>
    </div>
  );
}

export default function PartnersStrip() {
  const doubled = [...PARTNERS, ...PARTNERS];

  return (
    <section
      data-testid="partners-strip"
      className="py-16 lg:py-20 bg-[#F7F8FA] border-y border-[#E5E7EB]"
    >
      <div className="max-w-[1320px] mx-auto px-6 lg:px-10 mb-10 text-center">
        <p
          data-testid="partners-strip-eyebrow"
          className="eyebrow-teal"
        >
          Global Experience
        </p>
        <h2
          data-testid="partners-strip-title"
          className="mt-3 text-3xl lg:text-[40px] font-semibold tracking-tight text-[#071D49] leading-[1.1] max-w-3xl mx-auto"
        >
          Experience that moves across industries, languages, and borders.
        </h2>
        <p
          data-testid="partners-strip-sub"
          className="mt-4 text-[15px] lg:text-base text-[#5B6472] max-w-2xl mx-auto"
        >
          Our linguists have supported global brands and leading language providers.
        </p>
      </div>
      <div className="relative overflow-hidden marquee-pause-on-hover">
        <div className="flex w-max animate-marquee group">
          {doubled.map((name, i) => (
            <Mark key={`${name}-${i}`} name={name} />
          ))}
        </div>
        <div className="pointer-events-none absolute left-0 top-0 bottom-0 w-28 bg-gradient-to-r from-[#F7F8FA] to-transparent" />
        <div className="pointer-events-none absolute right-0 top-0 bottom-0 w-28 bg-gradient-to-l from-[#F7F8FA] to-transparent" />
      </div>
    </section>
  );
}
